import React, { useState } from 'react';
import { Modal, Spin } from 'antd';
import { Prospect } from 'types/common';
import useGetScriptSureToken from 'hooks/useGetScriptSureToken';
import useGetScriptSurePatientId from 'hooks/useGetScriptSurePatientId';
import { getScriptSureUrl } from 'constants/common';
import s from './s.module.less';

type Props = {
    open?: boolean;
    onClose?: () => void;
    prospect?: Prospect;
};

//https://scriptsure.stoplight.io/docs/scriptsure-api-v3-release/2i5hmd9i5i9zw-widgets#drug-list

const PrescriptionsReportsTable = ({ open, onClose, prospect }: Props) => {
    const [scriptToken, loadingScriptToken, fetchScriptToken] = useGetScriptSureToken();
    const [checked, setChecked] = useState(true);
    const [iframeLink, setIframeLink] = useState<string>('');
    const scriptSureUrl = getScriptSureUrl();

    React.useEffect(() => {
        //URL: URL: URL: https://ssu.scriptsure.com/widgets/report?sessiontoken=k_VZ3UbSC75MiSYeLOQ6N3adrPEEcRKT&darkmode=off
        if (scriptToken) {
            setIframeLink(`${scriptSureUrl}/widgets/report?sessiontoken=${scriptToken.sessionToken}&darkmode=off`);
        }
    }, [scriptToken]);

    return (
        <div className={s.wrap}>
            {
                !iframeLink && (
                    <Spin />
                )
            }
            {
                iframeLink && (
                    <iframe
                        src={iframeLink}
                        width="100%"
                        height="800px"
                        frameBorder="0"
                        title="Prescribe reports"
                    />
                )
            }
        </div>
    );
};

export default PrescriptionsReportsTable;
